import standardAction from '../../../utilities/standard-action';
import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function clearItemPricing(): RootActionTypes {
  return standardAction(ActionTypes.CLEAR_ITEM_PRICING);
}
